import { api, apiMipe } from '@/core/api/';

export const initPractitionerInternFilters = async () => {
  return await api.get('api/practitioner/initfilters');
};

export const getServiceTypes = async (fiscalYearId, companyId) => {
  return await api.get(
    `api/practitioner/servicetypes/${fiscalYearId}/${companyId}`
  );
};

export const getServices = async (fiscalYearId, companyId, serviceTypeId) => {
  return await api.get(
    `api/practitioner/services/${fiscalYearId}/${companyId}/${serviceTypeId}`
  );
};

export const getPractitioners = async (model) => {
  return await api.get('api/practitioner/', { params: { ...model } });
};

export const getPractitionersBySpecialist = async (specialistId, companyId) => {
  return await api.get(
    `api/practitioner/practitionersbyspecialist/${specialistId}/${companyId}`
  );
};

export const getPractitionersByCompany = (fiscalYearId, companyId) =>
  api.get(`api/practitioner/practitioners/${fiscalYearId}/${companyId}`);

export const getPractitionerInfo = (practitionerId, companyId) =>
  api.get(`api/practitioner/practitionerinfo/${practitionerId}/${companyId}`);

export const updatePractitionerInfo = (practitionerId, payload) =>
  api.put(`api/practitioner/updatepractitionerinfo/${practitionerId}`, payload);

export const updatePractitionerDocuments = (practitionerId, payload) =>
  api.put(
    `api/practitioner/updatepractitionerdocuments/${practitionerId}`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

export const getPractitionerSupervisors = (payload) =>
  api.get('api/practitioner/supervisors', {
    params: {
      ...payload,
    },
  });

export const changePractitionerStatus = (practitionerId, isActive) =>
  api.put(
    `api/practitioner/changepractitionerstatus/${practitionerId}/${isActive}`
  );

export const createPractitioner = async (model) => {
  return await api.post(`api/practitioner`, model, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getPractitionerDocumentTypes = async () => {
  return await apiMipe.get('api/documents/documenttypes', {
    params: { codeType: 'SPECPractitioner' },
  });
};

export const createSpecialistSpecialty = async (model) => {
  return await api.post(`/api/practitioner/specialty`, model);
};

export const editSpecialistSpecialty = async (model) => {
  return await api.put('/api/practitioner/specialty', model);
};

export const deleteSpecialistSpecialty = async (
  practitionerId,
  specialtyTypeId
) => {
  return await api.delete(
    `/api/practitioner/specialty/${practitionerId}/${specialtyTypeId}`
  );
};

export const checkPractitionerExistance = async (ssn) => {
  return await api.get(`api/practitioner/exists/${ssn}`);
};
